"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var TopGamesList_1 = require("./component/TopGamesList");
var TopGameEditor_1 = require("./component/TopGameEditor");
var PTopGamesList = /** @class */ (function (_super) {
    __extends(PTopGamesList, _super);
    function PTopGamesList(props) {
        return _super.call(this, props) || this;
    }
    PTopGamesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrandsAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AG = this.props.listGwsGameProvidersAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_gws_game_providers: data.data });
        });
        this.SID_AC = this.props.listAppCurrencyAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_app_currency: data.data });
        });
        this.SID_AT = this.props.listTopGameTypesAvail.Subscribe("*", function (id, data) {
            _this.setState({ avail_top_game_types: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_gws_game_providers: [],
            avail_app_currency: [],
            avail_top_game_types: []
        }, function () {
            _this.props.listBrandsAvail.LoadData();
            _this.props.listGwsGameProvidersAvail.LoadData();
            _this.props.listAppCurrencyAvail.LoadData();
            _this.props.listTopGameTypesAvail.LoadData();
        });
    };
    PTopGamesList.prototype.componentWillUnmount = function () {
        this.props.listBrandsAvail.UnSubscribe(this.SID_AB);
        this.props.listGwsGameProvidersAvail.UnSubscribe(this.SID_AG);
        this.props.listAppCurrencyAvail.UnSubscribe(this.SID_AC);
        this.props.listTopGameTypesAvail.UnSubscribe(this.SID_AT);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PTopGamesList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PTopGamesList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record: id });
    };
    PTopGamesList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PTopGamesList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PTopGamesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PTopGamesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(TopGameEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), brandsAvail: this.state.avail_brands, gwsGameprovidersAvail: this.state.avail_gws_game_providers, listCmsGamesetAvail: this.props.listCmsGamesetAvail, topGameTypesAvail: this.state.avail_top_game_types, listGwsGameProviderGamesAvail: this.props.listGwsGameProviderGamesAvail, appCurrencyAvail: this.state.avail_app_currency }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(TopGameEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), brandsAvail: this.state.avail_brands, gwsGameprovidersAvail: this.state.avail_gws_game_providers, listCmsGamesetAvail: this.props.listCmsGamesetAvail, topGameTypesAvail: this.state.avail_top_game_types, listGwsGameProviderGamesAvail: this.props.listGwsGameProviderGamesAvail, appCurrencyAvail: this.state.avail_app_currency }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(TopGamesList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, brandsList: this.state.brands_list, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PTopGamesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PTopGamesList.getPageDescription = function (state) {
        return {
            icon: "star",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_cms_top_games_list + "-id",
            itemTitle: "Топ игры",
            route: routes_1.routes.page_cms_top_games_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PTopGamesList;
}(React.Component));
exports.default = PTopGamesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_top_games/ui/PTopGamesList.tsx
// module id = 2351
// module chunks = 0